import React from 'react';

import Icon, { type IconName } from '@/components/icons';
import { logTrackingEvent } from '@/utils/tracking';
import { cn } from '@/lib/utils';

type SocialIcon = {
  iconName: IconName;
  url: string;
};

export type SocialLinksProps = {
  className?: string;
  socialIcons?: SocialIcon[];
  tagline?: string;
};

const SocialLinks = ({ className = '', socialIcons = [], tagline = '' }: SocialLinksProps) => (
  <div className={cn(className, 'flex items-center gap-3 md:gap-6')}>
    <span className="text-sm">{tagline}</span>
    {socialIcons.map(({ iconName, url }) => (
      <a
        key={iconName}
        href={url}
        aria-label={`link to ${iconName}`}
        onClick={() =>
          logTrackingEvent({
            event: 'navigation_click',
            navigation_type: 'main_nav',
            click_text: 'Social',
            click_url: url,
            nav_level: '2',
          })
        }
      >
        <Icon name={iconName} />
      </a>
    ))}
  </div>
);

export default SocialLinks;
